import React, { useState, useRef, FunctionComponent } from 'react'
import { globalState } from '../../../store'
import { toast } from 'react-toastify'
import { Range } from 'react-date-range'

import styled from 'styled-components'
import { usePost, notify } from '../../../components/component-items/helpers'

// Components
import GenericModal from '../../../components/component-items/modal'
import GlobalStyles from '../../../components/component-items/styles'
import { Form } from 'react-bootstrap'
import { CustomDateInput } from '../../../components/component-items/custom-date-input'

type StorageChargesModalTypes = {
  open: boolean
  setOpen: (open: boolean) => void
}

const InfoBox = styled.div`
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 1.5em;
  font-size: 0.9em;
  color: #495057;

  strong {
    color: #212529;
  }

  ul {
    margin: 8px 0 0 0;
    padding-left: 20px;
  }

  li {
    margin-bottom: 4px;
  }
`

export const StorageChargesModal: FunctionComponent<StorageChargesModalTypes> = ({ open, setOpen }) => {
  const node = useRef<HTMLFormElement | null>(null)
  const [validated, setValidated] = useState(false)
  const {
    state: { csrf },
  } = globalState()

  const [date, setDate] = useState<Date>(new Date())

  const handleSubmit = async (event: any) => {
    event.preventDefault()
    event.stopPropagation()
    setValidated(true)

    if (node?.current?.checkValidity() === false) {
      return
    }
    const resp = await usePost(
      '/api/company/run_storage_charges/',
      { month: date?.getMonth() + 1, year: date?.getFullYear() },
      csrf,
      false
    )
    if (!resp.error) {
      notify({
        type: 'success',
        title: 'Successfully Ran Storage Charges',
        message: 'This process can take up to an hour to complete.',
      })
      setOpen(false)
    }
  }

  const handleDateChange = (newDate: Date | Range | null) => {
    if (newDate instanceof Date) {
      setDate(newDate)
    }
  }

  return (
    <GenericModal
      heading={'Run Storage Charges'}
      show={open}
      onHide={() => setOpen(false)}
      buttons={
        <GlobalStyles.Button style={{ minWidth: 125 }} onClick={handleSubmit}>
          Run Storage Charges
        </GlobalStyles.Button>
      }
    >
      <Form noValidate ref={node} validated={validated} onSubmit={handleSubmit} style={{ margin: '0 2em 1em' }}>
        <InfoBox>
          <strong>How storage charges work:</strong>
          <ul>
            <li>
              <strong>First run:</strong> Creates storage charge transactions for the selected month.
            </li>
            <li>
              <strong>Re-run:</strong> If charges already exist for this month, an adjustment transaction will be
              created for the difference (original charges are preserved for reconciliation).
            </li>
          </ul>
        </InfoBox>
        <div style={{ margin: '1em auto', width: '80%', justifyContent: 'center', display: 'flex' }}>
          <Form.Group>
            <Form.Label>Month & Year</Form.Label>
            <CustomDateInput value={date} onChange={handleDateChange} required keepOpen placeholder="MM-YYYY" />
          </Form.Group>
        </div>
      </Form>
    </GenericModal>
  )
}
